import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import logo from "../../assets/logo.png";

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [servicesOpen, setServicesOpen] = useState(false);
  const close = () => { setOpen(false); setServicesOpen(false); };

  return (
    <header className="navbar">
      <div className="nav-container">

        {/* LOGO */}
        <NavLink to="/" className="nav-logo">
          <img src={logo} alt="Hand & Wrist Surgery" />
        </NavLink>

        {/* DESKTOP MENU */}
        <nav className="nav-menu">
          <NavLink to="/">Home</NavLink>
          <NavLink to="/about">About</NavLink>

          <div className="dropdown">
            <span className="dropdown-title">Services ▾</span>
            <div className="dropdown-menu">
              <NavLink to="/hand">Hand Surgery</NavLink>
              <NavLink to="/wrist">Wrist Surgery</NavLink>
              <NavLink to="/peripheral">Peripheral nerve surgery</NavLink>
              <NavLink to="/branchial">Brachial plexus surgery</NavLink>
            </div>
          </div>

          <NavLink to="/events-articles">Events & Articles</NavLink>
          <NavLink to="/gallery">Gallery</NavLink>
          <NavLink to="/testimonials">Testimonials</NavLink>
          <NavLink to="/contact" className="contact-btn">Contact</NavLink>
        </nav>

        {/* HAMBURGER */}
        <button
          className={`nav-toggle${open ? " is-open" : ""}`}
          onClick={() => setOpen(!open)}
          aria-label="Toggle menu"
          aria-expanded={open}
        >
          <span /><span /><span />
        </button>
      </div>

      {/* MOBILE BACKDROP */}
      {open && <div className="nav-backdrop" onClick={close} />}

      {/* MOBILE PANEL */}
      <div className={`nav-mobile-panel${open ? " is-open" : ""}`}>
        <NavLink to="/" onClick={close}>Home</NavLink>
        <NavLink to="/about" onClick={close}>About</NavLink>

        <button
          className="nav-mobile-services-toggle"
          onClick={() => setServicesOpen(!servicesOpen)}
        >
          Services
          <span className={`caret${servicesOpen ? " open" : ""}`}>▾</span>
        </button>

        {servicesOpen && (
          <div className="nav-mobile-submenu">
            <NavLink to="/hand" onClick={close}>Hand Surgery</NavLink>
            <NavLink to="/wrist" onClick={close}>Wrist Surgery</NavLink>
            <NavLink to="/peripheral" onClick={close}>Peripheral</NavLink>
            <NavLink to="/branchial" onClick={close}>Brachial</NavLink>
          </div>
        )}

        <NavLink to="/events-articles" onClick={close}>Events & Articles</NavLink>
        <NavLink to="/gallery" onClick={close}>Gallery</NavLink>
        <NavLink to="/testimonials" onClick={close}>Testimonials</NavLink>
        <NavLink to="/contact" className="contact-btn" onClick={close}>Contact</NavLink>
      </div>
    </header>
  );
}